var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealthSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63.011,
    viewBox: "0 0 63 63.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team_2_",
    "data-name": "team (2)",
    transform: "translate(-0.5 -0.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276713",
    "data-name": "Path 276713",
    d: "M2,18.5H16A1.5,1.5,0,0,0,17.5,17a8.5,8.5,0,0,0-4.345-7.408,5.5,5.5,0,1,0-8.31,0A8.5,8.5,0,0,0,.5,17,1.5,1.5,0,0,0,2,18.5ZM6.5,6A2.5,2.5,0,1,1,9,8.5,2.5,2.5,0,0,1,6.5,6ZM9,11.5a5.51,5.51,0,0,1,5.292,4H3.708A5.51,5.51,0,0,1,9,11.5Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276714",
    "data-name": "Path 276714",
    d: "M13.155,54.592a5.5,5.5,0,1,0-8.31,0A8.5,8.5,0,0,0,.5,62,1.5,1.5,0,0,0,2,63.5H16A1.5,1.5,0,0,0,17.5,62a8.5,8.5,0,0,0-4.345-7.407ZM6.5,51A2.5,2.5,0,1,1,9,53.5,2.5,2.5,0,0,1,6.5,51ZM3.708,60.5a5.5,5.5,0,0,1,10.584,0Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276715",
    "data-name": "Path 276715",
    d: "M59.155,54.592a5.5,5.5,0,1,0-8.31,0A8.5,8.5,0,0,0,46.5,62,1.5,1.5,0,0,0,48,63.5H62A1.5,1.5,0,0,0,63.5,62a8.5,8.5,0,0,0-4.345-7.407ZM52.5,51A2.5,2.5,0,1,1,55,53.5,2.5,2.5,0,0,1,52.5,51Zm-2.792,9.5a5.5,5.5,0,0,1,10.584,0Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276716",
    "data-name": "Path 276716",
    d: "M46.5,17A1.5,1.5,0,0,0,48,18.5H62A1.5,1.5,0,0,0,63.5,17a8.5,8.5,0,0,0-4.345-7.408,5.5,5.5,0,1,0-8.31,0A8.5,8.5,0,0,0,46.5,17Zm6-11A2.5,2.5,0,1,1,55,8.5,2.5,2.5,0,0,1,52.5,6ZM55,11.5a5.51,5.51,0,0,1,5.292,4H49.708A5.51,5.51,0,0,1,55,11.5Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276717",
    "data-name": "Path 276717",
    d: "M19,10.5H45a1.5,1.5,0,0,0,0-3H19a1.5,1.5,0,0,0,0,3Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276718",
    "data-name": "Path 276718",
    d: "M45,53.5H19a1.5,1.5,0,0,0,0,3H45a1.5,1.5,0,0,0,0-3Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276719",
    "data-name": "Path 276719",
    d: "M7.5,22V42a1.5,1.5,0,0,0,3,0V22a1.5,1.5,0,0,0-3,0Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276720",
    "data-name": "Path 276720",
    d: "M53.5,22V42a1.5,1.5,0,0,0,3,0V22a1.5,1.5,0,0,0-3,0Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276721",
    "data-name": "Path 276721",
    d: "M47.294,28.529,44.9,28.051a13.379,13.379,0,0,0-.988-2.379l1.354-2.032a1.5,1.5,0,0,0-.187-1.893l-2.828-2.828a1.5,1.5,0,0,0-1.893-.187l-2.032,1.354a13.379,13.379,0,0,0-2.379-.988l-.479-2.392A1.5,1.5,0,0,0,34,15.5H30a1.5,1.5,0,0,0-1.471,1.206L28.051,19.1a13.378,13.378,0,0,0-2.379.988L23.64,18.731a1.5,1.5,0,0,0-1.893.188l-2.828,2.828a1.5,1.5,0,0,0-.187,1.893l1.354,2.032a13.379,13.379,0,0,0-.988,2.379l-2.392.479A1.5,1.5,0,0,0,15.5,30v4a1.5,1.5,0,0,0,1.206,1.471l2.392.479a13.379,13.379,0,0,0,.988,2.379L18.731,40.36a1.5,1.5,0,0,0,.188,1.893l2.828,2.828a1.5,1.5,0,0,0,1.893.187l2.032-1.354a13.379,13.379,0,0,0,2.379.988l.479,2.392A1.5,1.5,0,0,0,30,48.5h4a1.5,1.5,0,0,0,1.471-1.206l.479-2.392a13.378,13.378,0,0,0,2.379-.988l2.032,1.354a1.5,1.5,0,0,0,1.893-.187l2.828-2.828a1.5,1.5,0,0,0,.188-1.893l-1.354-2.032a13.379,13.379,0,0,0,.988-2.379l2.392-.479A1.5,1.5,0,0,0,48.5,34V30a1.5,1.5,0,0,0-1.206-1.471ZM32,37a5,5,0,1,1,5-5A5,5,0,0,1,32,37Z",
    fill: "#fd930d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthSetting);
export default __webpack_public_path__ + "static/media/Mental_Health_Setting.a03095adf567361a254377b8f94fb0e8.svg";
export { ForwardRef as ReactComponent };